export default class Text {
    constructor(idioma) {
        this.idioma = idioma || 'br'
    }

    getTextoHeader1() {
        switch (this.idioma) {
            case 'br':
                return `Oferecemos o que há de`
            case 'us':
                return `We offer the`
            default:
                return `Undefined Language`
        }
    } 
    getTextoHeader2() {
        switch (this.idioma) {
            case 'br':
                return `melhor`
            case 'us':
                return `best`
            default:
                return `Undefined Language`
        }
    }

    getTextoHeader3() {
        switch (this.idioma) {
            case 'br':
                return `em`
            case 'us':
                return `in`
            default:
                return `Undefined Language`
        }
    }

    getTextoHeader4() {
        switch (this.idioma) {
            case 'br':
                return `soluções`
            case 'us':
                return `solutions`
            default:
                return `Undefined Language`
        }
    }

    getTextoHeader5() {
        switch (this.idioma) {
            case 'br':
                return `em`
            case 'us':
                return `in`
            default:
                return `Undefined Language`
        }
    }

    getTextoHeader6() {
        switch (this.idioma) {
            case 'br':
                return `tecnologia`
            case 'us':
                return `technology`
            default:
                return `Undefined Language`
        }
    }

    getTextoHome1() {
        switch (this.idioma) {
            case 'br':
                return `A `
            case 'us':
                return ``
            default:
                return `Undefined Language`
        }
    }

    getTextoHome2() {
        switch (this.idioma) {
            case 'br':
                return ` nasceu para a inovação e com ela cresceu, desenvolvendo iniciativas que sustentam o mercado em soluções viáveis e que se sobressaem como modelos de gestão em comércio, fábricas e setores públicos`
            case 'us':
                return ` was born for innovation, and has grew up with it, developing initiatives wich sustain the market in viable solutions wich stand out as management models in commerce, factories and public sections`
            default:
                return `Undefined Language`
        }
    }

    getTituloResumo1() {
        switch (this.idioma) {
            case 'br':
                return `Confiam em nosso serviço.`
            case 'us':
                return `Who trust in our service.`
            default:
                return `Undefined Language`
        }
    }

    getTituloResumo2() {
        switch (this.idioma) {
            case 'br':
                return `Fique tranquilo com os dados pessoais e \n informações importantes de sua emresa.`
            case 'us':
                return `Rest assured about your personal data and your business' important information.`
            default:
                return `Undefined Language`
        }
    }

    getTopico1() {
        switch (this.idioma) {
            case 'br':
                return `Larga experiência no fornecimento de serviços para redes sem fio, fornecendo consultoria, venda e Mão de obra e wireless.`
            case 'us':
                return `Large experience providing services for wireless networks, providing consulting, sales, labor and wireless.`
            default:
                    return `Undefined Language`
        }
    }

    getTopico2() {
        switch (this.idioma) {
            case 'br':
                return `Soluções em telecomunicações, telefonia e interfonia para empresas, consomínios e até mesmo residências.`
            case 'us':
                return `Solutions in telecommunications, telephony and intercom for companies, consom-even residences.`
            default:
                    return `Undefined Language`
        }
    }

    getTopico3() {
        switch (this.idioma) {
            case 'br':
                return `Montagem de servidores web, arquivos, firewall, dedicados, domínio, redundância e backup.`
            case 'us':
                return `Assembly of web servers, files, firewall, dedicated, domain, redundancy and backup.`
            default:
                    return `Undefined Language`
        }
    }

    getBotão2() {
        switch (this.idioma) {
            case 'br':
                return `Saiba mais`
            case 'us':
                return `Learn more`
            default:
                    return `Undefined Language`
        }
    }

    getTextoEquipe(){
        switch(this.idioma) {
            case 'br':
                return `Nossa equipe`
            case 'us':
                return `Our team`
            default:
                return `Undefined Language`
        }
    }

    getTextoRodape() {
        switch (this.idioma) {
            case 'br':
                return `As diretrizes e politicas de privacidade de informações de nossos clientes são entendidas como prioridade por toda equipe da City Connect. Desta forma não cedemos informações referentes a nossos clientes a terceiros.`
            case 'us':
                return `
                Our customers' information privacy policies and guidelines are understood as a priority by the entire City Connect team. In this way we do not give information about our customers to third parties.`
            default:
                return `Undefined Language`    
        }
    }

    getDireitosReservados() {
        switch (this.idioma) {
            case 'br':
                return `Todos os direitos reservados - @ City Connect`
            case 'us':
                return `All rights reserved - @ City Connect`
            default:
                    return `Undefined Language`
        }
    }

    getOsSystem() {
        switch (this.idioma) {
            case 'br': 
                return `Sistema de OS`
            case 'us':
                return `OS System`
            default: 
                return `Undefined Language`
        }        
    }

    getPassword() {
        
        switch (this.idioma) {
            case 'br':
                return `senha`
            case 'us':
                return `password`
            default:
                return `Undefined Language`
        }
    }

    getUsername() {
        switch (this.idioma) {
            case 'br':
                return `nome de usuário`
            case 'us':
                return `username`
            default:
                return `Undefined Language`
        }
    }

    getLogin() {
        switch (this.idioma) {
            case 'br':
                return `Entrar`
            case 'us':
                return `Sign in`
            default:
                return `Undefined Language`
        }
    }

    getLastText() {
        switch (this.idioma) {
            case 'br':
                return `A excelência no relacionamento com parceiros de diferentes níveis de maturidade e até mesmo na identificação de novas tendências de mercado credencia nossa empresa como seguidora de boas práticas sugeridas pelo mercado para gerenciamento e execução de projetos`
            case 'us':
                return `The excelence on our relationships with partners from different maturities levels and also on the identification of new tendences accredit our company as follower of market's good pratices on projects execution and management`
            default:
                return `Undefined Language`
        }
    }

    getBtnText() {
        switch (this.idioma) {
            case 'br':
                return `Nossos trabalhos`
            case 'us':
                return `Our work`
            default:
                return `Undefined Language`
        }
    }
}